var devicesWithPointer = false;
mediaTouchDevices();
if (!readCookie("joinTheMovementToast")) {
    setTimeout(() => {
        $('.toast-overlay').toast('show');
    }, 10000);
    createCookie("joinTheMovementToast", "1", 100);
} else {}

function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

getHeaderHeight();

function getHeaderHeight() {
    var headerHeight = document.querySelector('.site-header').offsetHeight;
    document.documentElement.style
        .setProperty('--header-height', headerHeight + 'px');
}

// Sticky Header
window.floatingHeaderLock = false;
$(window).on(
    'scroll',
    function () {
        if ($(window).scrollTop() > 0) {
            $('body').addClass('is-scrolling');
        } else {
            $('body').removeClass('is-scrolling');
        }
    }
).on(
    'load',
    function () {
        var $window = $(window);
        $window.on('scroll', function () {
            handleStickyHeader();
        });
        getHeaderHeight();
    }
);
handleStickyHeader();
var headerHeight = $('.site-header').height();
var lastScrollTop = 0;

function handleStickyHeader() {
    if (window.floatingHeaderLock) {
        return;
    }

    $('body').removeClass('is-scrolling-down');
    $('body').addClass('is-scrolling-up is-scrolling');
}

function lockFloatingHeader() {
    window.floatingHeaderLock = true;

    setTimeout(function () {
        window.floatingHeaderLock = false;
    }, 3000);
}
// --------------------------------------------------------------------

$(document).on(
    'click',
    function (event) {
        var target = $(event.target);
        var _mobileMenuOpen = $(".navbar-collapse").hasClass("show");
        if (_mobileMenuOpen === true && !target.hasClass("navbar-toggler")) {
            $('#siteNavigation').collapse('hide');
        }
    }
);

// Site Navigation Overflow Stopped on Navbar Toggle
$('#siteNavigation').on('show.bs.collapse', function () {
    $('body').addClass('overflow-stopped');

}).on('hide.bs.collapse', function () {
    $('body').removeClass('overflow-stopped');
})


$('a[smooth-scroll]').on('click', function (event) {
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
    event.preventDefault();
});

// --------------------------------------------------------------------
__typerAnim = $(".typer-anim");
$.each(__typerAnim, function (indexInArray, valueOfElement) {
    var words = $(this).data('rotate');
    $(this).typer({
        strings: words,
        typeSpeed: 60,
        backspaceSpeed: 80,
        backspaceDelay: 800,
        repeatDelay: 1000,
        repeat: true,
        autoStart: true,
    });
});

// Text Marquee

// if ($('.marquee-init').length) {
//     var $marquee = $('.marquee-init');

//     $.each($marquee, function (indexInArray, marqueeElement) {
//         const flickityMarquee = new Flickity(marqueeElement, {
//             accessibility: true,
//             resize: true,
//             wrapAround: true,
//             prevNextButtons: false,
//             pageDots: false,
//             percentPosition: true,
//             setGallerySize: true,
//             draggable: false,
//         });

//         flickityMarquee.x = 0;

//         flickityMarqueePlay();

//         function flickityMarqueePlay() {
//             flickityMarquee.x -= 2;

//             flickityMarquee.settle(flickityMarquee.x);

//             requestId = window.requestAnimationFrame(flickityMarqueePlay);
//         }
//     });
// }

// Featured Collection Slider
var $productsCarousel = $(document).find('.sliderInit');
$productsCarousel.flickity({
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false,
    contain: true,
    wrapAround: false,
    cellAlign: 'left',
    selectedAttraction: 0.3,
    friction: 0.9
});

// Announcement Bar Slider
// var $announcementCarousel = $(document).find('.announcementSlider');
// $announcementCarousel.flickity({
//     wrapAround: true,
//     imagesLoaded: true,
//     cellAlign: 'center',
//     pageDots: false,
//     prevNextButtons: false,
//     draggable: false,
//     autoPlay: 'true',
// });

var __showCaseCarousels = $('.featured-collections__showcase .product-blocks--carousel-sm');

$.each(__showCaseCarousels, function (indexInArray, valueOfElement) {
    var carouselMobileOnly = true;

    if ($(this).is('.sliderInit')) {
        carouselMobileOnly = false
    }

    $(this).flickity({
        imagesLoaded: true,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        watchCSS: carouselMobileOnly
    });
});

var $reviewsCarousel = $('.generic-carousel-wrapper .carouselInit');
$reviewsCarousel.flickity({
    wrapAround: true,
    imagesLoaded: true,
    cellAlign: 'left',
    pageDots: true,
});

var __ingredientsCarousels = $('.ingredients .generic-carousel-wrapper .ingredients--carousel-sm');

$.each(__ingredientsCarousels, function (indexInArray, valueOfElement) {
    var carouselMobileOnly = true;

    if ($(this).is('.carouselinit')) {
        carouselMobileOnly = false
    }

    $(this).flickity({
        wrapAround: true,
        imagesLoaded: true,
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        watchCSS: carouselMobileOnly
    });
});


var $ingredientsCarousel = $('.ingredients .generic-carousel-wrapper .carouselinit');
$ingredientsCarousel.flickity({
    wrapAround: true,
    imagesLoaded: true,
    cellAlign: 'left',
    pageDots: false,
    prevNextButtons: true,
});

// var $productRecommendationsCarousel = $('.product-recommendations .carouselinit');
// $productRecommendationsCarousel.flickity({
//     wrapAround: true,
//     imagesLoaded: true,
//     cellAlign: 'left',
//     pageDots: false,
//     prevNextButtons: false,
//     watchCSS: true,
// });

var $brandsTestimonialsCarousel = $('.brands-testimonials .carouselInit');
$brandsTestimonialsCarousel.flickity({
    wrapAround: true,
    imagesLoaded: true,
    cellAlign: 'left',
    pageDots: true,
});

var $brandsTestimonialsCarouselNav = $('.brands-testimonials .carousel-init');
$brandsTestimonialsCarouselNav.flickity({
    wrapAround: false,
    contain: true,
    imagesLoaded: true,
    cellAlign: 'center',
    pageDots: false,
    asNavFor: '.brands-testimonials--carousel',
    prevNextButtons: false,
    draggable: false
});

var $cartCarousel = $('.cart-carousel .carouselInit');
$cartCarousel.flickity({
    wrapAround: false,
    contain: true,
    imagesLoaded: true,
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: false,
});

var $productDetailCarousel = $(document).find('.product-sliderInit');
$productDetailCarousel.flickity({
    imagesLoaded: true,
    prevNextButtons: false,
    contain: true,
});

/*-- Cart Drawer Function --*/
$('.cart-sidebar__toggler').on('click', function (e) {
    e.preventDefault();
    $('.cart-sidebar').toggleClass('show');
    $('.cart-sidebar__overlay').fadeToggle();
});

$('.cart-sidebar__overlay').on('click', function (e) {
    e.preventDefault();
    $('.cart-sidebar').toggleClass('show');
    $(this).fadeToggle();
});

// Product Quantity
$('.btn-number').on('click', function (e) {
    e.preventDefault();
    var qty_btn = $(this);
    updateInput(qty_btn);
});

function updateInput(qty_btn) {
    fieldName = qty_btn.attr('data-field');
    type = qty_btn.attr('data-type');
    var input = qty_btn.siblings("input[name='" + fieldName + "']");
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
        if (type == 'minus') {
            if (currentVal > input.attr('min')) {
                input.val(currentVal - 1).change();
            }
            if (parseInt(input.val()) == input.attr('min')) {
                qty_btn.attr('disabled', true);
            }
        } else if (type == 'plus') {
            if (currentVal < input.attr('max')) {
                input.val(currentVal + 1).change();
            }
            if (parseInt(input.val()) == input.attr('max')) {
                qty_btn.attr('disabled', true);
            }
        }
    } else {
        input.val(0);
    }
}
$('.input-number').on('focusin', function () {
    $(this).data('oldValue', $(this).val());
});
$('.input-number').on('change', function () {
    minValue = parseInt($(this).attr('min'));
    maxValue = parseInt($(this).attr('max'));
    valueCurrent = parseInt($(this).val());
    name = $(this).attr('name');
    if (valueCurrent >= minValue) {
        $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr(
            'disabled')
    } else {
        alert('Sorry, the minimum value was reached');
        $(this).val($(this).data('oldValue'));
    }
    if (valueCurrent <= maxValue) {
        $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
        alert('Sorry, the maximum value was reached');
        $(this).val($(this).data('oldValue'));
    }
});
$(".input-number").on('keydown', function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode >
            105)) {
        e.preventDefault();
    }
});

$('.menu-drawer--toggler').on('click', function (e) {
    e.preventDefault();
    $('.header__icon--menu').trigger('click');
});

$('.product-modals-btn .btn').on('click', function (e) {
    e.preventDefault();
    $('.modal-backdrop').fadeIn();
});

$('.modal').on('show.bs.modal', function (e) {
    $('body').css('padding-right', (window.innerWidth - document.getElementsByTagName('html')[0].clientWidth) + 'px')
}).on('hidden.bs.modal', function (e) {
    $('body').css('padding-right', '0')
});

// var marqueeEl = $('.marquee');
// $.each(marqueeEl, function (indexInArray, valueOfElement) {
//     $(this).addClass('marquee-initialized');
//     // $(this).marquee({
//     //     duration: 15000,
//     //     gap: 0,
//     //     delayBeforeStart: 0,
//     //     direction: 'left',
//     //     duplicated: true 
//     // });
//     let element = $(valueOfElement)

// });


let marqueeSwipers = document.querySelectorAll('.marquee.swiper');

marqueeSwipers.forEach(element => {
    let speed = parseInt(element.dataset.marqueeSpeed);
    if (speed) {} else {
        speed = 5000
    }
    let marqueeSwiper = new Swiper(element, {
        spaceBetween: 0,
        // centeredSlides: true,
        speed: speed,
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false,
        observer: true,
        autoplay: {
            delay: 0.1,
            disableOnInteraction: false,
            // waitForTransition: false,
        },
    });
});

let brandsMarquee = $('.brands-logo--marquee');
$.each(brandsMarquee, function (indexInArray, valueOfElement) {
    let slideImages = $(valueOfElement).find('.swiper-slide .swiper-slide__img');
    $.each(slideImages, function (indexInArray, valueOfElement) {
        $(this).attr('src', $(this).data('src'));
    });
});
setTimeout(() => {}, 200);


// AOS.init();
$(window).on(
    'load',
    function () {
        setTimeout(() => {
            $('.flickity-enabled:not(.marquee-init)').flickity('resize');
        }, 200);

        // setTimeout(() => {
        //     var reviewTextLink = $('.product-card .yotpo-bottomline .text-m');
        //     $.each(reviewTextLink, function (indexInArray, valueOfElement) {
        //         var text = $(this).text();
        //         var number = parseInt(text, 10);
        //         $(this).text(number).closest('.product-reviews').css('opacity', '1');
        //     });
        // }, 500);
    }
);

// Color label update on swatch select
$('.product-form__input input[type="radio"][name="Color"]').on('change', function (e) {
    $('.product-form__input .product-colors__label p').text($(this).val());
});

// hide or show notify button
$(window).on('load', function () {
    setTimeout(() => {
        let buy_button_status = $('.btn--addCart[disabled]');
        let payment_button = $('.shopify-payment-button');
        if (buy_button_status.length) {
            $('.btn-notify').removeClass('d-none');
            payment_button.addClass('d-none');
        } else {
            $('.btn-notify').addClass('d-none');
            payment_button.removeClass('d-none');
        }
    }, 1000);
});
// $(window).on('load', function () {
//     setTimeout(() => {
//         if ($('.shopify-payment-button__button[disabled]').length) {
//             $('.btn-notify').removeClass('d-none');

//         } else {

//             $('.btn-notify').addClass('d-none');
//         }
//     }, 1000);
// });

$('.product-form__input input[type="radio"][name="Size"]').on('change', function (e) {
    setTimeout(() => {
        toggleNotify();
    }, 1000);
});

function toggleNotify() {
    let buy_button_status = $('.btn--addCart[disabled]');
    let payment_button = $('.shopify-payment-button');
    if (buy_button_status.length) {
        $('.btn-notify').removeClass('d-none');
        payment_button.addClass('d-none');
    } else {
        $('.btn-notify').addClass('d-none');
        payment_button.removeClass('d-none');
    }
}

const swiperWithNav = new Swiper(".swiperWithNav", {
    speed: 600,
    allowTouchMove: !0,
    grabCursor: !0,
    loop: !1,
    slidesPerView: 'auto',
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumVelocityRatio: .3,
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: !0
    },
    mousewheel: !0,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
});


var announcementSwiper = new Swiper(".announcement-swiper", {
    speed: 600,
    allowTouchMove: !0,
    grabCursor: !0,
    loop: true,
    slidesPerView: 1,
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumVelocityRatio: .3,
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: !0
    },
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    mousewheel: !0,
    mousewheel: {
        forceToAxis: !0
    },
});


var testimonialsSlider = new Swiper(".brands-testimonials--carousel--nav", {
    speed: 600,
    allowTouchMove: !0,
    grabCursor: !0,
    loop: !1,
    slidesPerView: 4,
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumVelocityRatio: .3,
    watchSlidesProgress: true,
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: !0
    },
    mousewheel: !0,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },

});
var swiper2 = new Swiper(".testimonialsSlider", {
    speed: 600,
    allowTouchMove: !0,
    grabCursor: !0,
    loop: !1,
    slidesPerView: 'auto',
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumVelocityRatio: .3,
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: !0
    },
    mousewheel: !0,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    thumbs: {
        swiper: testimonialsSlider,
    },
});

$(function () {
    loopcounter('launched-count-down-old');
});

const cd = new Date().getFullYear() + 1
$('#countdown').countdown({
    year: 2022, // YYYY Format
    month: 2, // 1-12
    day: 11, // 1-31
    hour: 03, // 24 hour format 0-23
    minute: 00, // 0-59
    second: 00, // 0-59
    timezone: -5
});

function missFameVideo(e) {
    e.preventDefault();

    var __videoEl = $('#missFameVideo');
    var __btnWithIcon = $('.miss-fame .video-control');

    if (__videoEl.is('.paused')) {
        __videoEl.removeClass('paused').addClass('playing').trigger('play');
        __btnWithIcon.removeClass('paused').addClass('playing');
    } else {
        __videoEl.addClass('paused').removeClass('playing').trigger('pause');
        __btnWithIcon.addClass('paused').removeClass('playing');
    }
}

$('.sustainabilityVideoModal').on('hidden.bs.modal', function () {
    $(this).find('.modal-video').attr('src', '');
});

$(".sustainabilityVideoModal").on('show.bs.modal', function () {
    var _videoSource = $(this).find('.modal-video').data('src');
    $(this).find('.modal-video').attr('src', _videoSource);
});

$(document).find('.select-wrapper').each(function () {
    var _this = $(this);
    var btnClass = _this.data('button-style');
    let select_picker = _this.find('.select-picker');
    if (typeof (select_picker) != 'undefined') {
        // console.log(select_picker);
        select_picker.selectpicker({
            style: '',
            styleBase: btnClass,
            width: false
        });
    }
});

var testimonialsSwiper = new Swiper(".testimonial-swiper", {
    speed: 600,
    allowTouchMove: !0,
    grabCursor: !0,
    loop: !1,
    slidesPerView: 'auto',
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumVelocityRatio: .3,
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: !0
    },
    mousewheel: !0,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
});

var featuredCarousel = new Swiper(".featured-carousel--main", {
    speed: 600,
    allowTouchMove: !0,
    grabCursor: !0,
    loop: !1,
    slidesPerView: 'auto',
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumVelocityRatio: .3,
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: !0
    },
    mousewheel: !0,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
});

var skinTypeCarousel = new Swiper(".skin-type-carousel", {
    speed: 600,
    allowTouchMove: !0,
    grabCursor: !0,
    loop: !1,
    slidesPerView: 'auto',
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumVelocityRatio: .3,
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: !0
    },
    mousewheel: !0,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    },
});

$('.custom-accordions__nav-link').on('click', function (e) {
    e.preventDefault();
    let $target = $(this).data('target');

    if ($(this).is('.active')) {
        $(this).removeClass('active');
        $($target).removeClass('active').slideUp();
    } else {
        $('.custom-accordions__nav-link').removeClass('active');
        $(this).addClass('active');
        $('.custom-accordions__tab-pane').slideUp();
        $($target).addClass('active').slideDown();
    }
});

var imageWithContentTestimonials = new Swiper(".image-with-content--testimonials .swiper", {
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    slidesPerView: 'auto',
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
});

/*  $('.site-header').on('mouseenter', function () {
    if (devicesWithPointer) {
        $(this).find('.dropdown-toggle').attr('aria-expanded', true);
        $(this).find('.dropdown-menu').addClass('show');
        $('.header__inline-menu details').attr("open", true);
        $('body').addClass('megamenu-opened');
    }
}).on('mouseleave', function () {
    if (devicesWithPointer) {
        // $(this).find('.dropdown-toggle').dropdown('hide').attr('aria-expanded', false);
        $(this).find('.dropdown-toggle').attr('aria-expanded', false);
        $(this).find('.dropdown-menu').removeClass('show');

        $('.header__inline-menu details').attr("open", false);
        $('body').removeClass('megamenu-opened');
    }
}); 

$('[id^="Details-"] summary').on('click', function () {
    console.log('Cliked');
    if ($(this).closest('details').attr('open') == true || $(this).closest('details').attr('open') == 'open') {
        $('.site-header').find('.dropdown-toggle').attr('aria-expanded', false);
        $('.site-header').find('.dropdown-menu').removeClass('show');
    } else {
        $('.site-header').find('.dropdown-toggle').attr('aria-expanded', true);
        $('.site-header').find('.dropdown-menu').addClass('show');
    }
}); */
$('.site-header').on('mouseenter', '.dropdown-toggle', function () {
    if (devicesWithPointer) {
        $(this).attr('aria-expanded', true);
        $(this).siblings('.dropdown-menu').addClass('show');
        $(this).closest('details').attr("open", true);
        $('body').addClass('megamenu-opened');
    }
}).on('mouseleave', '.dropdown-toggle', function () {
    if (devicesWithPointer) {
        $(this).attr('aria-expanded', false);
        $(this).siblings('.dropdown-menu').removeClass('show');
        $(this).closest('details').attr("open", false);
        $('body').removeClass('megamenu-opened');
    }
});

$('ul.list-menu > li').on('mouseenter', function () {
    console.log('Hovered');
    const detailsElement = $(this).find('details');
    detailsElement.attr('open', true);
    detailsElement.find('summary').attr('aria-expanded', true);
    detailsElement.find('.dropdown-menu').addClass('show');
}).on('mouseleave', function () {
    const detailsElement = $(this).find('details');
    detailsElement.attr('open', false);
    detailsElement.find('summary').attr('aria-expanded', false);
    detailsElement.find('.dropdown-menu').removeClass('show');
});


// $('#languageMobileCollapse').collapse('show')

$(window).on('resize', function () {
    mediaTouchDevices();
});

$('.collapse-btn-overlay').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).siblings('.language-collapse-toggler').toggleAttrVal('aria-expanded', "true", "false")
    $('#languageMobileCollapse').collapse('toggle');
});

function mediaTouchDevices() {
    if (window.matchMedia('(any-hover: none)').matches) {
        devicesWithPointer = false;
    } else {
        devicesWithPointer = true;
    }
}
// jquery toggle just the attribute value
$.fn.toggleAttrVal = function (attr, val1, val2) {
    var test = $(this).attr(attr);
    if (test === val1) {
        $(this).attr(attr, val2);
        return this;
    }
    if (test === val2) {
        $(this).attr(attr, val1);
        return this;
    }
    // default to val1 if neither
    $(this).attr(attr, val1);
    return this;
};
var setLocations = () => {
    const countries_list = $("a[data-country-name]");
    console.log(countries_list);
    const home = $('body').data('home');
    for (let index = 0; index < countries_list.length; index++) {
        const element = $(countries_list[index]);
        if (element.attr('href') == home) {
            const image = element.data('location-image');
            const name = element.data('country-name');
            const selected_locations = $('.selected_location');
            const selected_image = $('.selected_location_img');
            selected_locations.text(name);
            selected_image.attr("src", image);
        }
    }
    countries_list.on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const target = "https://" + e.target.getAttribute('href');
        // console.log(e.target.getAttribute('href'), home);
        // window.open(e.target.getAttribute('href'),"_self")
        window.location.replace(target);
    })
}
setLocations();